function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.46 18a2.23 2.23 0 01-.91-.2 1.76 1.76 0 01-1.05-1.59V7.79A1.76 1.76 0 019.55 6.2a2.1 2.1 0 012.21.26l5.1 4.21a1.7 1.7 0 010 2.66l-5.1 4.21a2.06 2.06 0 01-1.3.46z",
  "data-name": "arrow-right"
}));

function SvgIconTriangleRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGcgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBkYXRhLW5hbWU9ImFycm93LXJpZ2h0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHRyYW5zZm9ybT0icm90YXRlKDE4MCAxMiAxMikiIG9wYWNpdHk9IjAiLz48cGF0aCBkPSJNMTAuNDYgMThhMi4yMyAyLjIzIDAgMCAxLS45MS0uMiAxLjc2IDEuNzYgMCAwIDEtMS4wNS0xLjU5VjcuNzlBMS43NiAxLjc2IDAgMCAxIDkuNTUgNi4yYTIuMSAyLjEgMCAwIDEgMi4yMS4yNmw1LjEgNC4yMWExLjcgMS43IDAgMCAxIDAgMi42NmwtNS4xIDQuMjFhMi4wNiAyLjA2IDAgMCAxLTEuMy40NnoiLz48L2c+PC9nPjwvc3ZnPg==";
export { SvgIconTriangleRight as ReactComponent };